
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { SecurityApiClient } from "../clients/SecurityApiClient";
import { IAuthenticationResult } from "./models/IAuthenticationResult";
import { IAuthenticationParameters } from "./models/IAuthenticationParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class LoginInformationService
{
	private readonly url: string;

	constructor(private readonly apiClient: SecurityApiClient)
    {
        this.url = "logininformation";
    }

    async authenticate(parameters: IAuthenticationParameters): Promise<IAuthenticationResult>
    {
        return await this.apiClient.post<IAuthenticationResult>(`${this.url}/authenticate`,{},JSON.stringify(parameters));
    }
}
